export default __webpack_public_path__ + "static/media/Ko-fi_Icon_RGB_stroke.7ef0d47a.png";